

















































































































import { Component, Prop, Ref, Vue, Watch, PropSync } from 'vue-property-decorator';
import CardTitle from '@/components/common/CardTitle.vue';
import BarChart from '@/components/chart/BarChart.vue';
import { CHART_TYPES, CHART_TYPE_NAMES } from '@/utils/ChartTypes';
import Modelling from '@/store/modules/Modelling';
import { getModule } from 'vuex-module-decorators';
import Decisions from '@/store/modules/Decisions';
import Viewpoints from '@/store/modules/Viewpoints';
import WorkspaceOptions from '@/store/modules/WorkspaceOptions';
import Choices from '@/store/modules/Choices';
import Scoring from '@/store/modules/Scoring';
import { ApexChartOptions, HistogramChartOptions, BarChartOptions } from '@/api/model/ApexChartOptions';


const workspaceOptions = getModule(WorkspaceOptions);
const modellingModule = getModule(Modelling);
const decisionsModule = getModule(Decisions);
const viewpointModule = getModule(Viewpoints);
const choicesModule = getModule(Choices);

@Component({
    components: {
        BarChart,
        CardTitle,
        HistogramChart
    },
})
export default class HistogramChart extends Vue {
    @Prop({ default: '', type: String })
    factorId!: string;
    @Prop({ default: '', type: String })
    currentViewpointId!: string;
    @Prop({ type: Boolean, default: true })
    isHistogram!: boolean;
    @Prop({ type: String, default: '' })
    xTitle!: string;
    @Prop({ type: String, default: '' })
    yTitle!: string;

    private items = CHART_TYPES;
    private CHART_TYPE_NAMES = CHART_TYPE_NAMES;
    private isLoading = false;
    private open = false;
    private tooltipShow = false;
    private task: any;

    private chartData = {
        data: {
            series: [],
        },
        title: {
            text: '',
        },
        xaxis: {
            categories: [],
        },
    };


    private cancelTask() {
        clearTimeout(this.task);
    }

    private chartDataDelay() {
        this.task = setTimeout(() => {this.getChartData() }, 800);
    }


    get isHistogramChart() {
        if (this.factors[this.factorId].hasOwnProperty('valueTypeDefinition')) {
            const numTypes = ['NUMERICAL', 'DATE_TIME']
            
            return numTypes.includes(this.factors[this.factorId]['valueTypeDefinition']['valueType'])
        }
        return false;
    }

    get isBarCount() {
        if(this.isHistogramChart) {
            
            return false} else {
            
            return true
        }
    }

    get factors() {
        return modellingModule.publishedModelFactorResources;
    }

    get decisionId() {
        return decisionsModule.selectedDecisionId;
    }

    get activeViewpointId() {
        return viewpointModule.activeViewpointId;
    }

    get selectedViewpointIds() {
        return viewpointModule.selectedViewpointIds;
    }

    get viewpoints() {
        return viewpointModule.unfilteredViewpointsMap;
    }
    get activeChoiceId() {
        return choicesModule.selectedChoiceId;
    }
    

    private async getChartData() {
        
        try {
            if (this.factorId !== '') {
                this.isLoading = true;
                const factor = this.factors[this.factorId];
                
                const res = await getModule(Scoring).getHistogramFactorData({numeric: this.isHistogramChart, decisionId:this.decisionId, viewpointId: this.activeViewpointId, viewpointIds:this.selectedViewpointIds, 
                factorId:this.factorId, factorParentId:factor.id, choiceId: choicesModule.selectedChoice.id}); 
                if (Object.keys(res).length > 0) {
                    this.chartData = res  //[this.activeViewpointId]
                
                }
                this.isLoading = false;
            }
        } catch (error) {
            console.log("ERROR", error);
        }
    }
}
